import moment from 'moment'
import { TabError } from '@/utils/class/TabError'
import StrUtils from '@/utils/StrUtils'
import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as BillReleaseType from '@/class/cargo/model/parameters/BillReleaseType'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import { DocCommon } from '@/class/cargo/model/utils/DocCommon'
import { SeaExportUtils } from '@/class/cargo/model/utils/SeaExportUtils'
import { Company } from '@/class/model/mdm/Company'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { SeaImCargoDoc } from '@/class/model/booking/SeaImCargoDoc'
import { AfrAddress } from '@/class/model/booking/AfrAddress'
import { Vessel } from '@/class/model/mdm/Vessel'
import { Voyage } from '@/class/model/mdm/Voyage'
import { unJointSlavesHblOrMbl } from '@/api/SeaImport/seaImportJob'
import AbstractViewManage from '@/class/view/AbstractViewManage'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import { surrendered } from '@/api/seaExport/seaCargoDoc'
import { File } from '@/class/model/booking/File'
import * as FileType from '@/class/cargo/model/parameters/FileType'
import { PrintUtils } from '@/utils/PrintUtils'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as BlModeType from '@/class/cargo/model/parameters/BlModeType'
import { sortByMultiFieldAndOrder } from '@/utils'

export class TabHBL2PM extends AbstractViewManage {
  /**
  * @param {Object} view 视图
  */
  constructor(view) {
    super(view)
    this.view = view
    this._hblCargoDoc = null
    this.addrPM = null
    this.prompt1TitleWindow = null
    this.promptTitleWindow = null
    this._editWindow = null
    this.afrAddressWindow = null
    this.usageSelectWindow = null
    this.originalPrintCheckSerialNo = false // 提单流水号打印验证
    this.joinMBLs = []
    this._allowEditingVessel = false
    this.editVesselVoyageMode = 2 // 船名编辑模式
    this.editVoyageMode = 2 // 航次
    this._voyages = null
    this._lclslaveEnabled = false
    this.dfSignDateHBLDisabledRanges = null
    this.mergerOfEnglishNames = 0
    this.currentVessel = null
    this.printParam4Type = [
      { label: '', data: '' },
      { label: 'AS CARRIER', data: 'AS CARRIER' },
      { label: 'AS AGENT FOR THE CARRIER', data: 'AS AGENT FOR THE CARRIER' },
      { label: 'AS AGENT FOR ', data: 'AS AGENT FOR ' }
    ]
    this.printParam5Type = [
      { label: '', data: '' },
      { label: 'SEABRIDGE FCL', data: 'DELIVERY ORDER FEE ON ACCOUNT OF CNEE' },
      { label: 'SEABRIDGE LCL NORMAL', data: 'DESTINATION CFS CHARGES INCL.DELIVERY ORDER FEE AND GSC CHARGES ON ACCOUNT OF CNEE' },
      { label: 'SEABRIDGE LCL INCLUDE CISF', data: 'DESTINATION CFS CHARGES INCL.DELIVERY ORDER FEE AND GSC CHARGES AND CISF ON ACCOUNT OF CNEE' }
    ]
    this.removeJointJob = null // 删除并单
    this.view.$nextTick(() => {
      this.creationCompleteHandler()
    })
    // _view.dgFreightCharges.addEventListener(KeyboardEvent.KEY_DOWN, freightChargesHandler)
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    this.view.context = context
  }
  get companyList() {
    return this.view.context.companyList
  }
  set companyList(companyList) {
    this.view.context.companyList = companyList
  }
  get paymentTermList() {
    return this.view.context.paymentTermList
  }
  set paymentTermList(paymentTermList) {
    // 不可赋值
  }
  get packingList() {
    return this.view.context.packingList
  }
  set packingList(packingList) {
    // 不可赋值
  }
  get shippingTermList() {
    return this.view.context.shippingTermList
  }
  set shippingTermList(shippingTermList) {
    // 不可赋值
  }
  get user() {
    return this.context.user
  }
  set user(user) {
    // 不可赋值
  }
  get config() {
    return this.view.config
  }
  set config(config) {
    // 不可赋值
  }
  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }
  get form() {
    return this.view.form
  }
  set form(form) {
    this.view.addrPM = new BillAddressCommonPM(this.view)
    this.view.addrPM.job = this.job
    this.view.form = form
    console.log('this.view.form', this.view.form)
  }
  /**
   * init
   */
  init() {
    this.view.maxChars = 45
    this.originalPrintCheckSerialNo = Number(this.config.get('originalPrintCheckSerialNo')) === 1
    this.editVesselVoyageMode = Number(this.config.get('EditVesselVoyageMode'))
    this.editVoyageMode = Number(this.config.get('EditVoyageMode'))
    this.mergerOfEnglishNames = Number(this.config.get('MergerOfEnglishNames'))
    this.editInputVesselModel()

    getSpecificBasicData(basicCacheKeys.basic_data_BlMode).then(data => {
      for (const item of data) {
        if (item.blType === BlModeType.HBL.code) {
          this.view.blModeList.push(item)
        }
      }
    })
  }
  /**
   * creationComplete
   */
  creationCompleteHandler() {
    this.lclslaveEnabledCl()
  }
  async display() {
    const job = new SeaImportJob(this.job)
    this.job.seaCargoDoc = ''
    const cargoDoc = await job.getSeaCargoDoc()
    console.log('qingqiu cargoDoc', cargoDoc)
    await this.loadCargoDoc2Handler(cargoDoc)
    const jointSlavesHBL = await job.getJointSlavesHBL()
    this.loadJointSlaves2Handler(jointSlavesHBL)
  }
  changeJob() {
  }
  fillView() {
    this.form.vessel = this.job.vessel
    this.editInputVesselModel()
    this.refreshQuantitySum()
    this.lclslaveEnabledCl()
    this.ETD_changeCl()
    if (!this.form.freightTermHBL) {
      const shippingTerm = this.shippingTermList.find(p => p.code === this.job.freightTermHBL)
      if (shippingTerm) {
        this.form.freightTermHBL = shippingTerm.name
      }
    }
    if (!this.view.mblId && this.joinMBLs.length > 0) {
      this.view.mblId = this.joinMBLs[0].uuid
      this.form.mblId = this.view.mblId
    }
  }
  async fillModel() {
    // 提单发货地
    this.form.dispatchingPlace = this.form.dispatchingPlace.toUpperCase()
    // 提单起运港
    this.form.loadingPort = this.form.loadingPort.toUpperCase()
    // 提单卸货港
    this.form.dischargingPort = this.form.dischargingPort.toUpperCase()
    // 提单目的港
    this.form.destinationPort = this.form.destinationPort.toUpperCase()
    // 关联主单
    if (this.joinMBLs.length === 0) {
      this.form.mblId = await this.getMBLCargoDoc()
    }
    // 提单目的地
    this.form.destinationPlace = this.form.destinationPlace.toUpperCase()
    // 提单份数
    this.form.blNumber = this.form.blNumber.toUpperCase()
    // 英文品名
    // this.form.cargoEnglishName = this.form.cargoEnglishName.toUpperCase()
    // 唛头
    // this.form.mark = this.form.mark.toUpperCase()
    // 提单备注
    this.form.remarks = this.form.remarks.toUpperCase()
    this.form.seaeq = this.form.seaeq.toUpperCase()
    this.form.container = this.form.container.toUpperCase()
    this.form.alsoNotify = this.form.alsoNotify.toUpperCase()

    // 多个hbl 时不能保存对应的勾选标识bug await this.changeAfrAddress()
  }

  async getMBLCargoDoc() {
    await new SeaImportJob(this.job).getCargoDoc()
    for (const doc of this.job.cargoDoc) {
      if (doc.docType === CargoDocConsts.MBL) {
        return doc.uuid
      }
    }
    return ''
  }
  print() {
    // if (null == view.cargoDoc) {
    //   this.$message.warning(this.view.$t('Message.NoSelectedCargoDocInformation'))
    //   return
    // }
    // var params1 = new Object()
    // if (view.job.typeHBL == BillType.SPLIT_BILL_TYPE.code) {
    //   if (view.gdHBL2.selectedItem) {
    //     params1.jobuuid = view.job.key
    //     params1.cargoDocUuid = view.cargoDoc.key
    //     params1.fileAliasName = view.cargoDoc.hblNbr2
    //     params1.DOC_UUID = view.cargoDoc.key
    //     TemplateSelectorWin.getInstance().showThisWin(view.job, 'HBL2', params1, view)
    //   }
    //   else {
    //     this.$message.warning(this.view.$t('Message.NoSelectedCargoDocInformation'))
    //   }
    // }
    // else if (view.job.typeHBL == BillType.MERGE_BILL_TYPE.code) {
    //   if (view.cargoDoc) {
    //     params1.jobuuid = view.job.key
    //     params1.cargoDocUuid = view.cargoDoc.key
    //     params1.fileAliasName = view.cargoDoc.hblNbr2
    //     params1.DOC_UUID = view.cargoDoc.key
    //     TemplateSelectorWin.getInstance().showThisWin(view.job, 'HBL2', params1, view)
    //   }
    // }
  }
  validateForm() {
    let _t_quantity = 0
    let _t_weight = 0
    let _t_cubage = 0
    if (this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code) {
      for (const item_hCargoDoc of this.job.cargoDoc) {
        if (item_hCargoDoc.docType === CargoDocConsts.HBL2) {
          // 件数
          _t_quantity += Number(item_hCargoDoc.quantity)
          // 重量
          _t_weight += Number(item_hCargoDoc.weight)
          // 体积
          _t_cubage += Number(item_hCargoDoc.cubage)
        }
      }
      console.log('job.quantityActual', this.job.quantityActual, _t_quantity, this.job.weightActual, _t_weight, this.job.cubageActual, _t_cubage)
      if ((_t_quantity !== 0 && _t_quantity !== Number(this.job.quantityActual)) ||
        (_t_weight !== 0 && _t_weight.toFixed(2) !== Number(this.job.weightActual).toFixed(2)) ||
        (_t_cubage !== 0 && _t_cubage.toFixed(3) !== Number(this.job.cubageActual).toFixed(3))) {
        this.view.$t('Message.TotalWeightOfLadingAreInconsistent')
      }
    } else if (this.job.typeHBL === BillType.MERGE_BILL_TYPE.code) {
      for (const item_hCargoDoc2 of this.job.seaCargoDoc) {
        if (item_hCargoDoc2.docType === CargoDocConsts.HBL) {
          // 件数
          _t_quantity += Number(item_hCargoDoc2.quantity)
          // 重量
          _t_weight += Number(item_hCargoDoc2.weight)
          // 体积
          _t_cubage += Number(item_hCargoDoc2.cubage)
          break
        }
      }
      // 并单件毛体
      for (const job of this.job.jointSlavesHBL) {
        // 件数
        _t_quantity += Number(job.quantityActual)
        // 重量
        _t_weight += Number(job.weightActual)
        // 体积
        _t_cubage += Number(job.cubageActual)
      }
      if (this.form.quantity && this.form.weight && this.form.cubage && ((_t_quantity !== 0 && _t_quantity !== Number(this.form.quantity)) ||
        (_t_weight !== 0 && _t_weight.toFixed(2) !== Number(this.form.weight).toFixed(2)) ||
        (_t_cubage !== 0 && _t_cubage.toFixed(3) !== Number(this.form.cubage).toFixed(3)))) {
        this.view.$t('Message.TotalWeightOfLadingAreInconsistent')
      }
    }
    if (this.form.releaseType && this.form.releaseType === BillReleaseType.SURRENDERED.code) {
      const regexp = /^\W*to\W*-?\W*order\W*$/i
      const _txtconsigneeLine1 = this.form.consigneeLine1.toLocaleLowerCase()
      if (regexp.test(_txtconsigneeLine1)) {
        throw new TabError(this.view.$t('Message.TOORDERIsUnavailableToRelease'), 'tabHBL2')
      }
    }
    return true
  }
  executeTask() {
    DocCommon.HBL_History.shipperLine1 = this.form.shipperLine1
    DocCommon.HBL_History.shipperLine2 = this.form.shipperLine2
    DocCommon.HBL_History.shipperLine3 = this.form.shipperLine3
    DocCommon.HBL_History.shipperLine4 = this.form.shipperLine4
    DocCommon.HBL_History.shipperLine5 = this.form.shipperLine5
    DocCommon.HBL_History.shipperLine6 = this.form.shipperLine6
    DocCommon.HBL_History.shipperCode = this.shipperCode
    DocCommon.HBL_History.consigneeLine1 = this.form.consigneeLine1
    DocCommon.HBL_History.consigneeLine2 = this.form.consigneeLine2
    DocCommon.HBL_History.consigneeLine3 = this.form.consigneeLine3
    DocCommon.HBL_History.consigneeLine4 = this.form.consigneeLine4
    DocCommon.HBL_History.consigneeLine5 = this.form.consigneeLine5
    DocCommon.HBL_History.consigneeLine6 = this.form.consigneeLine6
    DocCommon.HBL_History.consigneeCode = this.form.consigneeCode
    DocCommon.HBL_History.notifyLine1 = this.form.notifyLine1
    DocCommon.HBL_History.notifyLine2 = this.form.notifyLine2
    DocCommon.HBL_History.notifyLine3 = this.form.notifyLine3
    DocCommon.HBL_History.notifyLine4 = this.form.notifyLine4
    DocCommon.HBL_History.notifyLine5 = this.form.notifyLine5
    DocCommon.HBL_History.notifyLine6 = this.form.notifyLine6
    DocCommon.HBL_History.notifyCode = this.form.notifyCode
    DocCommon.HBL_History.englishCargoName = this.form.cargoEnglishName
    DocCommon.HBL_History.mark = this.form.mark
    if (parseInt(this.config.get('syncMailingAddress')) === 1) {
      this.view.addrPM.saveCheck()
    }
    // addJoinMergeJobList.removeAll()
    this.view.addJoinMergeJobList.splice(0, this.view.addJoinMergeJobList.length)
  }
  /**
   * 抄录收货人
   */
  onCopy_consignee(evt) {
    this.form.notifyCode = this.form.consigneeCode
    this.form.notifyLine1 = this.form.consigneeLine1
    this.form.notifyLine2 = this.form.consigneeLine2
    this.form.notifyLine3 = this.form.consigneeLine3
    this.form.notifyLine4 = this.form.consigneeLine4
    this.form.notifyLine5 = this.form.consigneeLine5
    this.form.notifyLine6 = this.form.consigneeLine6
    this.form.notifyLine7 = this.form.consigneeLine7
  }
  /**
   *  抄录1
   */
  onCopy1() {
    this.form.shipperCode = DocCommon.HBL_History.shipperCode || ''
    this.form.shipperLine1 = DocCommon.HBL_History.shipperLine1 || ''
    this.form.shipperLine2 = DocCommon.HBL_History.shipperLine2 || ''
    this.form.shipperLine3 = DocCommon.HBL_History.shipperLine3 || ''
    this.form.shipperLine4 = DocCommon.HBL_History.shipperLine4 || ''
    this.form.shipperLine5 = DocCommon.HBL_History.shipperLine5 || ''
    this.form.shipperLine6 = DocCommon.HBL_History.shipperLine6 || ''

    this.form.consigneeCode = DocCommon.HBL_History.consigneeCode || ''
    this.form.consigneeLine1 = DocCommon.HBL_History.consigneeLine1 || ''
    this.form.consigneeLine2 = DocCommon.HBL_History.consigneeLine2 || ''
    this.form.consigneeLine3 = DocCommon.HBL_History.consigneeLine3 || ''
    this.form.consigneeLine4 = DocCommon.HBL_History.consigneeLine4 || ''
    this.form.consigneeLine5 = DocCommon.HBL_History.consigneeLine5 || ''
    this.form.consigneeLine6 = DocCommon.HBL_History.consigneeLine6 || ''

    this.form.notifyCode = DocCommon.HBL_History.notifyCode || ''
    this.form.notifyLine1 = DocCommon.HBL_History.notifyLine1 || ''
    this.form.notifyLine2 = DocCommon.HBL_History.notifyLine2 || ''
    this.form.notifyLine3 = DocCommon.HBL_History.notifyLine3 || ''
    this.form.notifyLine4 = DocCommon.HBL_History.notifyLine4 || ''
    this.form.notifyLine5 = DocCommon.HBL_History.notifyLine5 || ''
    this.form.notifyLine6 = DocCommon.HBL_History.notifyLine6 || ''

    this.form.cargoEnglishName = DocCommon.HBL_History.englishCargoName || ''
    this.form.mark = DocCommon.HBL_History.mark || ''
  }
  async onSplitSelectionChange(event) {
    if (!event.data) {
      return
    }
    this.fillModel()
    this.form = event.data
    // 运输条款要手动赋值
    this.job.freightTermHBL = this.form.freightTermHBL
    this.editingChanged()
  }
  /**
   * 新增并单或者拆单
   */
  async onAddCargoDoc2() {
    if (this.form) {
      const joinMBLs = this.joinMBLs.filter(p => p.uuid)
      if (!this.form.mblId && joinMBLs.length > 0 && this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code) {
        this.$message.warning(this.view.$t('Message.TheAssociatedPrimaryFormIsNotSelected'))
        return
      }
      if (this.form.releaseType && this.form.releaseType === BillReleaseType.SURRENDERED.code) {
        const regexp = /^\W*to\W*-?\W*order\W*$/i
        if (regexp.test(this.form.consigneeLine1)) {
          this.$message.warning(this.view.$t('Message.TOORDERIsUnavailableToRelease'))
          return
        }
      }
      await this.fillModel()
    }
    this.form = new SeaImCargoDoc().fillDefaultValue().getData()
    this.form.afrAddress = []
    await SeaImCargoDoc.copyInfoFromSeaImportJob(this.job, this.form)
    this.form.docType = CargoDocConsts.HBL2
    if (this._hblCargoDoc) {
      this.form.shipperLine1 = this._hblCargoDoc.shipperLine1
      this.form.shipperLine2 = this._hblCargoDoc.shipperLine2
      this.form.shipperLine3 = this._hblCargoDoc.shipperLine3
      this.form.shipperLine4 = this._hblCargoDoc.shipperLine4
      this.form.shipperLine5 = this._hblCargoDoc.shipperLine5
      this.form.shipperLine6 = this._hblCargoDoc.shipperLine6
      this.form.shipperLine7 = this._hblCargoDoc.shipperLine7
      this.form.shipperCode = this._hblCargoDoc.shipperCode

      this.form.consigneeLine1 = this._hblCargoDoc.consigneeLine1
      this.form.consigneeLine2 = this._hblCargoDoc.consigneeLine2
      this.form.consigneeLine3 = this._hblCargoDoc.consigneeLine3
      this.form.consigneeLine4 = this._hblCargoDoc.consigneeLine4
      this.form.consigneeLine5 = this._hblCargoDoc.consigneeLine5
      this.form.consigneeLine6 = this._hblCargoDoc.consigneeLine6
      this.form.consigneeLine7 = this._hblCargoDoc.consigneeLine7
      this.form.consigneeCode = this._hblCargoDoc.consigneeCode

      this.form.notifyLine1 = this._hblCargoDoc.notifyLine1
      this.form.notifyLine2 = this._hblCargoDoc.notifyLine2
      this.form.notifyLine3 = this._hblCargoDoc.notifyLine3
      this.form.notifyLine4 = this._hblCargoDoc.notifyLine4
      this.form.notifyLine5 = this._hblCargoDoc.notifyLine5
      this.form.notifyLine6 = this._hblCargoDoc.notifyLine6
      this.form.notifyLine7 = this._hblCargoDoc.notifyLine7
      this.form.notifyCode = this._hblCargoDoc.notifyCode

      this.form.agentPartyLine1 = this._hblCargoDoc.agentPartyLine1
      this.form.agentPartyLine2 = this._hblCargoDoc.agentPartyLine2
      this.form.agentPartyLine3 = this._hblCargoDoc.agentPartyLine3
      this.form.agentPartyLine4 = this._hblCargoDoc.agentPartyLine4
      this.form.agentPartyLine5 = this._hblCargoDoc.agentPartyLine5
      this.form.agentPartyLine6 = this._hblCargoDoc.agentPartyLine6
      this.form.agentPartyLine7 = this._hblCargoDoc.agentPartyLine7

      this.form.alsoNotify = this._hblCargoDoc.alsoNotify

      this.form.blNumber = this._hblCargoDoc.blNumber
      this.form.quantity = this.job.quantityActual
      this.form.weight = this.job.weightActual
      this.form.cubage = this.job.cubageActual
      this.form.chargeWeight = this.job.chargeWeight
      this.form.paymentPlaceBL = this._hblCargoDoc.paymentPlaceBL
      this.form.signPlaceBL = this._hblCargoDoc.signPlaceBL
      this.form.signDateBL = this._hblCargoDoc.signDateBL
      // 包装
      this.form.packing = this.job.packing
      // 英文品名
      this.form.cargoEnglishName = this._hblCargoDoc.cargoEnglishName
      // 唛头
      this.form.mark = this._hblCargoDoc.mark
      // 备注
      this.form.remarks = this._hblCargoDoc.remarks
      // 付款方式
      const paymentTerm = this.paymentTermList.find(p => p.code === this.job.paymentTermHBL)
      this.form.paymentTerm = paymentTerm ? paymentTerm.name : ''
      this.form.releaseType = this._hblCargoDoc.releaseType

      await new SeaImportJob(this.job).getSeaCargoDoc()
      const _hblCargoDocs = this.job.seaCargoDoc
      for (const item of _hblCargoDocs) {
        if (item.docType === CargoDocConsts.HBL2) {
          console.log('item', item, this.form.quantity)
          // 件数
          this.form.quantity = this.form.quantity - item.quantity
          // 重量
          this.form.weight = this.form.weight - item.weight
          // 体积
          this.form.cubage = this.form.cubage - item.cubage
        }
      }
      console.log('this.form.quantity', this.form.quantity)
      if (isNaN(this.form.weight)) {
        this.form.weight = 0
      }
      if (isNaN(this.form.cubage)) {
        this.form.cubage = 0
      }
    }
    this.form.hblNbr2 = this.job.jobNo + '-' + (this.view.splitOrder.rowData.length + 1)
    this.form.warehouseNo = this.job.jobNo + '-' + (this.view.splitOrder.rowData.length + 1)
    this.form.state = 1
    this.form.jobUuid = this.job.uuid
    if (this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code || this.job.typeHBL === BillType.MERGE_BILL_TYPE.code) {
      this.view.splitOrder.rowData.push(this.form)
      this.job.seaCargoDoc.push(this.form)
      this.view.$nextTick(() => { // 选中新增项
        const nodes = this.view.splitOrder.gridOptions.api.getRenderedNodes()
        nodes[nodes.length - 1].setSelected(true)
      })
      if (this.joinMBLs.length === 0) {
        this.form.mblId = await this.getMBLCargoDoc()
      }
    }

    this.editingChanged()
    this.refreshSeaeqNumber()
    this.refreshQuantitySum()
    this.form.insideQuantity = this.job.insideQuantity
    this.form.insidePacking = this.job.insidePacking
  }
  onRemoveCargoDoc() {
    const rows = this.view.splitOrder.gridApi.getSelectedRows()
    if (rows.length > 0) {
      this.$confirm(
        this.view.$t('Message.AreYouSureYouWantToDelete1') + rows[0].hblNbr2 + this.view.$t('Message.AreYouSureYouWantToDelete2'),
        this.view.$t('Message.ConfirmDelete'), {
          confirmButtonText: this.view.$t('common.btn.ok'),
          cancelButtonText: this.view.$t('common.btn.cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.onRemoveConfirmed(rows[0])
      }).catch(() => { })
    } else {
      this.$message.warning(this.view.$t('Message.PleaseSelectHBLNo'))
    }
    // 多行文本框设为不可输入，随后延时恢复为可输入状态，解决文本框赋值时，光标聚焦在文本框的问题
    this.view.textareaDisabled = true
    setTimeout(() => {
      this.view.textareaDisabled = false
    }, 1)
  }
  onRemoveConfirmed(row) {
    if (row.uuid) {
      row.deleted = true
      const tempRowData = this.view.splitOrder.rowData
      this.view.splitOrder.rowData = []
      this.view.$nextTick(() => {
        this.view.splitOrder.rowData = tempRowData
      })
      const cargoDoc = this.job.seaCargoDoc.find(p => p.uuid === row.uuid)
      if (cargoDoc) cargoDoc.deleted = true
    } else {
      const index = this.view.splitOrder.rowData.findIndex(p => p === row)
      if (index > -1) {
        this.view.splitOrder.rowData.splice(index, 1)
      }
      const cargoDocIndex = this.job.seaCargoDoc.findIndex(p => p === row)
      if (cargoDocIndex >= 0) {
        this.job.seaCargoDoc.splice(cargoDocIndex, 1)
      }
    }
    if (this.view.splitOrderFinalRowData.length > 0) {
      this.form = this.view.splitOrderFinalRowData[0]
      this.printStateChange()
    } else {
      // 不存到数据库
      this.form = new SeaImCargoDoc().fillDefaultValue().getData()
      this.editingChanged()
    }
    this.refreshSeaeqNumber()
    this.refreshQuantitySum()
    this.view.$nextTick(() => { // 选中新增项
      const nodes = this.view.splitOrder.gridOptions.api.getRenderedNodes()
      if (nodes.length > 0) {
        nodes[0].setSelected(true)
      }
    })
  }
  /**
   * 添加并单
   */
  onMergeAddJob() {
    this.job.key = this.job.uuid
    Object.assign(this.view.searchJobNoDialog.params, {
      selectType: 'multiple',
      docType: this.form.docType,
      job: this.job,
      useDefaultCondition: true
    })
    this.view.searchJobNoDialog.selectHandler = p => { this.selectionItemsHandler(p) }
    this.view.searchJobNoDialog.visible = true
  }
  /**
   * 删除并单
   */
  onMergeRemoveJob() {
    const job = this.view.mergeOrder.gridApi.getSelectedRows()[0]
    if (job) {
      this.$confirm(
        this.view.$t('Message.AreYouSureYouWantToDelete1') + job.jobNo + this.view.$t('Message.AreYouSureYouWantToDelete2'),
        this.view.$t('Message.ConfirmDelete'), {
          confirmButtonText: this.view.$t('common.btn.ok'),
          cancelButtonText: this.view.$t('common.btn.cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.onJobsRemoveConfirmed(job)
      }).catch(() => { })
    } else {
      this.$message.warning(this.view.$t('SeaExport.SelectAPieceOfData'))
      return
    }
  }
  onJobsRemoveConfirmed(job) {
    // 先保留原始的值，如果调用后端请求失败，则还原这几个字段
    const oldCargoDoc = {
      quantity: this.form.quantity,
      weight: this.form.weight,
      cubage: this.form.cubage,
      chargeWeight: this.form.chargeWeight
    }
    // 件数
    const quantity = this.form.quantity - job.quantityActual
    // 重量
    const weight = this.form.weight - job.weightActual
    // 体积
    const cubage = this.form.cubage - job.cubageActual
    // 计费重量
    const chargeWeight = this.form.chargeWeight - job.chargeWeight
    // 如果提单是已经真是存在的,此时立即调用移除并单操作，并且已经真实并入的才能调用后台
    if (this.form.uuid && job && job.jointMasterHBLUuid && job.joinFlagHBL) {
      const param = {}
      param.docType = 'HBL2'
      param.job = { key: this.job.uuid, version: this.job.version }
      param.unJob = { key: job.uuid, version: job.version }
      param.cargoDoc = {
        key: this.form.uuid,
        version: this.form.version,
        quantity: isNaN(quantity) ? 0 : Number(quantity),
        weight: isNaN(weight) ? 0 : Number(weight),
        cubage: isNaN(cubage) ? 0 : Number(cubage),
        chargeWeight: isNaN(chargeWeight) ? 0 : Number(chargeWeight)
      }
      unJointSlavesHblOrMbl(param).then(res => {
        if (res.data) { // 由于是编辑状态下,所以删除操作成功以后要更新对应的字段以及版本号
          const index = this.view.mergeOrder.rowData.findIndex(p => p.uuid === job.uuid)
          if (index >= 0) {
            this.view.mergeOrder.rowData.splice(index, 1)
          }
          if (res.data.job) {
            this.job.version = res.data.job.version
            this.job.joinFlagHBL = res.data.job.joinFlagHBL
            this.job.jointMasterHBLUuid = res.data.job.jointMasterHBLUuid
            this.view.$emit('syncData', {
              jointMasterHBLUuid: this.job.jointMasterHBLUuid,
              joinFlagHBL: this.job.joinFlagHBL,
              version: this.job.version
            })
          }
          if (res.data.cargoDoc) {
            this.form.version = res.data.cargoDoc.version
            this.form.quantity = res.data.cargoDoc.quantity
            this.form.weight = res.data.cargoDoc.weight
            this.form.cubage = res.data.cargoDoc.cubage
            this.form.chargeWeight = res.data.cargoDoc.chargeWeight
            this.view.$emit('syncData', { cargoDoc: '', seaCargoDoc: '', isCompleteRow: false })
          }
          this.view.$emit('syncData', { jointSlavesHBL: '', isCompleteRow: false })
        }
      }).catch(() => {
        this.form.quantity = oldCargoDoc.quantity
        this.form.weight = oldCargoDoc.weight
        this.form.cubage = oldCargoDoc.cubage
        this.form.chargeWeight = oldCargoDoc.chargeWeight
      })
    } else {
      // 移除addJoinMergeJobList中的数据
      const addJoinMergeJobList = this.view.addJoinMergeJobList
      if (addJoinMergeJobList && addJoinMergeJobList.length > 0) {
        for (let i = 0; i < addJoinMergeJobList.length; i++) {
          if (addJoinMergeJobList[i].key === job.uuid) {
            addJoinMergeJobList.splice(i, 1)
            break
          }
        }
      }
      const index = this.view.mergeOrder.rowData.findIndex(p => p.uuid === job.uuid)
      if (index >= 0) {
        this.view.mergeOrder.rowData.splice(index, 1)
      }
      this.form.quantity = quantity
      this.form.weight = weight
      this.form.cubage = cubage
      this.form.chargeWeight = chargeWeight
    }
  }
  /**
   * 获取真实的件毛体信息
   */
  getUnJointDocUpdateParam() {
    // var param = {}
    // param.job = view.job
    // param.unJob = removeJointJob
    // param.cargoDoc = view.cargoDoc
    // return param
  }
  saveAllSuccessHandler(result) {
    // if (addJoinMergeJobList != null && addJoinMergeJobList.length > 0) {
    //   addJoinMergeJobList.removeItemAt(addJoinMergeJobList.getItemIndex(removeJointJob))
    // }
    // removeJointJob.reloadJointSlavesHBL(new Responder(loadJointSlaves2Handler, view.faultHandler))
  }
  selectionItemHandler(rows) {
    const selectedHBL = rows[0]
    if (selectedHBL && Object.keys(selectedHBL).length > 0) {
      this.form.shipperCode = selectedHBL.shipperCode
      this.form.shipperLine1 = selectedHBL.shipperLine1
      this.form.shipperLine2 = selectedHBL.shipperLine2
      this.form.shipperLine3 = selectedHBL.shipperLine3
      this.form.shipperLine4 = selectedHBL.shipperLine4
      this.form.shipperLine5 = selectedHBL.shipperLine5
      this.from.shipperLine6 = selectedHBL.shipperLine6

      this.form.consigneeCode = selectedHBL.consigneeCode
      this.form.consigneeLine1 = selectedHBL.consigneeLine1
      this.form.consigneeLine2 = selectedHBL.consigneeLine2
      this.form.consigneeLine3 = selectedHBL.consigneeLine3
      this.form.consigneeLine4 = selectedHBL.consigneeLine4
      this.form.consigneeLine5 = selectedHBL.consigneeLine5
      this.form.consigneeLine6 = selectedHBL.consigneeLine6

      this.form.notifyCode = selectedHBL.notifyCode
      this.form.notifyLine1 = selectedHBL.notifyLine1
      this.form.notifyLine2 = selectedHBL.notifyLine2
      this.form.notifyLine3 = selectedHBL.notifyLine3
      this.form.notifyLine4 = selectedHBL.notifyLine4
      this.form.notifyLine5 = selectedHBL.notifyLine5
      this.form.notifyLine6 = selectedHBL.notifyLine6

      this.form.cargoEnglishName = this.job.cargoEnglishName
      this.form.mark = this.job.mark
    }
  }
  async selectionItemsHandler(selectedJobs) {
    const rowData = this.view.mergeOrder.rowData
    let usages = []
    const jobKeySet = {}
    for (const seaJob of rowData) {
      jobKeySet[seaJob.uuid] = true
      if (seaJob.containerUsages && seaJob.containerUsages.length > 0) {
        usages = usages.concat(seaJob.containerUsages)
      }
    }
    for (const sJob of selectedJobs) {
      if (!jobKeySet[sJob.uuid]) {
        rowData.push(sJob)
        this.view.addJoinMergeJobList.push({ masterJobUuid: this.job.uuid, key: sJob.uuid, version: sJob.version, type: 'HBL' })
      }
      if (sJob.containerUsages && sJob.containerUsages.length > 0) {
        usages = usages.concat(sJob.containerUsages)
      }
    }
    // this.view.mergeOrder.rowData = [...rowData]
    SeaExportUtils.jointJobsHBL(this.job, this.form, selectedJobs)
    this.refreshQuantitySum()
    const obj = SeaExportUtils.jointSeqContainerInfo(this.form.seaeq, this.form.container, this.job, this.form, selectedJobs, Number(this.form.chargeWeight))

    // mergerOfEnglishNames 参数不存在
    /* if (this.mergerOfEnglishNames === 1) {
      this.form.cargoEnglishName = obj.cargoEnglishName2
    } else {
      this.form.cargoEnglishName = obj.cargoEnglishName
    }*/
    this.form.cargoEnglishName = obj.cargoEnglishName
    this.form.chargeWeight = obj.chargeWeight
  }
  /**
   * 复制主单收货人
   */
  async onCopy_agentParty() {
    const mdoc = await new SeaImportJob(this.job).getMainMbl()
    if (mdoc) {
      this.form.agentPartyLine1 = mdoc.consigneeLine1
      this.form.agentPartyLine2 = mdoc.consigneeLine2
      this.form.agentPartyLine3 = mdoc.consigneeLine3
      this.form.agentPartyLine4 = mdoc.consigneeLine4
      this.form.agentPartyLine5 = mdoc.consigneeLine5
      this.form.agentPartyLine6 = mdoc.consigneeLine6
    }
  }
  /**
   * 取指定货代理信息
   */
  onCopy_designationAgent() {
    const cpy = this.context.companyList.find(p => p.cmpIdx === this.job.designationAgent)
    if (cpy) {
      cpy.overseaAgentDetail = ''
      new Company(cpy).getOverseaAgentDetail().then(data => {
        this.loadDestinationAgentHandler(data)
      })
    }
  }
  loadDestinationAgentHandler(overseaAgentDetail) {
    if (overseaAgentDetail) {
      this.form.agentPartyLine1 = overseaAgentDetail.blAddress
      this.form.agentPartyLine2 = overseaAgentDetail.blAddressLine2
      this.form.agentPartyLine3 = overseaAgentDetail.blAddressLine3
      this.form.agentPartyLine4 = overseaAgentDetail.blAddressLine4
      this.form.agentPartyLine5 = overseaAgentDetail.blAddressLine5
      this.form.agentPartyLine6 = overseaAgentDetail.blAddressLine6
    }
  }

  /**
   * refresh  刷新计件重体
   */
  refreshEdiGrid() {
    const pakInfo = this.view.container.rowData
    if (pakInfo) {
      let quantity = 0
      let weight = 0.000
      let cubage = 0.000
      for (const container of pakInfo) {
        quantity += container.quantity
        weight += container.weight
        cubage += container.cubage
      }
      this.form.quantity = quantity
      this.form.weight = weight
      this.form.cubage = cubage
    }
  }
  /**
   * 拆单计费重量修改计算
   */
  calculateChargeWeight() {
    let weight = Number(this.form.weight)
    const cubage = Number(this.form.cubage)
    if (isNaN(weight) || isNaN(cubage)) {
      return
    }
    weight = weight / 1000
    if (cubage > weight) {
      weight = cubage
    }
    if (weight > 0 && weight < 1) {
      weight = 1.00
    }
    this.form.chargeWeight = weight.toFixed(3)
  }
  /**
   *  提单类型
   */
  cmbreleaseTypeMBLChangeHandler(val) {
    if (Number(val) === 1) {
      this.form.blNumber = 'THREE'
    } else {
      this.form.blNumber = 'ONE'
    }
  }
  /**
   * 锁定按钮处理
   */
  onUnlockStateEvent(evt) {
    // view.cargoDoc.state = 1
    // view.cargoDoc.save2(loadJointSlaves2Handler, view.faultHandler)
  }
  packing_Change(data) {
    this.form.packing = data.value
    this.refreshQuantitySum()
  }
  quantity_Change() {
    this.refreshQuantitySum()
  }
  print_callback(event) {
    if (event.action === 'print') {
      this.form.state = 2
      surrendered({ cargoDocUuid: this.form.uuid, cfmState: this.form.cfmState, state: this.form.state }).then(async res => {
        if (res.data) {
          Object.assign(this.form, res.data)
        }
        this.loadJointSlaves2Handler()
      }).finally(() => {
        this.startCreateFile()
      })
    }
  }
  v2CheckCallbackFun2(printed, template, entity, params) {
    if (printed && params.event && params.event.action === PrintUtils.PRINT) {
      this.form.cfmState = 10
      this.form.state = 2
      surrendered({ cargoDocUuid: this.form.uuid, cfmState: this.form.cfmState, state: this.form.state }).then(async res => {
        if (res.data) {
          Object.assign(this.form, res.data)
        }
        this.loadJointSlaves2Handler()
      }).finally(() => {
      })
    }
  }
  /**
   * 开始创建File
   */
  async startCreateFile() {
    if (!this.form) { return }
    const count = await File.queryFilesCount({ 'jobNo': this.job.jobNo, 'fileNo': this.form.hblNbr2 })
    await this.fileCountResultHandler(count)
  }

  async fileCountResultHandler(count = 0) {
    if (count <= 0) { await this.createFileOnPrintZB() } else {
      this.$message.warning('already exists a same file!')
    }
  }
  fileCountFaultHandler(fault) {
    // LOGGER.error('query file count fault:' + fault.toString())
  }
  /**
   * 生成单证流转在打印正本的时候
   */
  async createFileOnPrintZB() {
    const file = await File.createFileByJob(this.job)
    file.fileType = FileType.HBL_TYPE.code + ''
    file.fileNo = this.form.hblNbr2
    await File.saveFile(file)
  }

  saveFileResultHandler(result) {
    // LOGGER.debug('generate HBL file success!')
  }
  saveFileFaultHandler(fault) {
    // LOGGER.error('generate HBL file fault!', fault.toString())
  }
  // 锁定按钮处理
  onSubmitStatEvent(event) {
    this.form.state = 1
    surrendered({ cargoDocUuid: this.form.uuid, state: this.form.state }).then(async res => {
      if (res.data) {
        Object.assign(this.form, res.data)
      }
      this.loadJointSlaves2Handler()
    }).finally(() => {
    })
  }
  /**
   * 船名选择
   */
  onVesselSelectionChange(data) {
    this.job.vessel = data.value.toUpperCase()
    this.currentVessel = null
    if (data.uuid) {
      this.currentVessel = data
    }
    this.getVoyageByVessel()
    if (this.currentVessel) {
      new Vessel(this.currentVessel).getVesselCarriers().then(data => {
        this.getVesselCarrier(data)
      })
    }
  }
  /**
   * 获取船舶呼号code
   */
  getVesselCarrier(vesselCarriers) {
    for (const carrier of vesselCarriers) {
      if (carrier.carrierId === this.job.carrierId) {
        this.job.vesselCode = carrier.ediCode
        break
      }
    }
  }
  async getVoyageByVessel() {
    if (this.currentVessel) {
      this._voyages = await Voyage.getVoyage(this.currentVessel.vesselId)
    } else {
      this._voyages = []
    }
  }
  txtVoyagefocusInHandler() {
    if (!this.job.voyageFlight) {
      this.job.voyageFlight = 'V.'
    }
  }
  async txtVoyagefocusOutHandler() {
    const job = this.job
    if (job.bookingTerm === BookingTerm.SB_BOOKING_TYPE.code && job.destinationPortCode && job.destinationPortCode.length && job.carrierId) {
      if (job.vessel && job.voyageFlight.length > 2) {
        const ediCode = await Vessel.getEDICode(job.vessel, job.voyageFlight, job.destinationPortCode, job.carrierId)
        if (ediCode) {
          job.vesselCode = ediCode
        }
      }
    }
  }
  paymentTermHBL_Change(value) {
    this.job.paymentTermHBL = value
    if (value === 'PP') {
      this.form.paymentPlaceHBL = this.form.loadingPort
    } else {
      this.form.paymentPlaceHBL = this.form.destinationPort
    }
  }
  paymentSelectHblChange(data) {
    this.paymentTermHBL_Change(data.value)
  }
  freightChargesHandler(freightCharges) {
    this.view.rowData = freightCharges
  }
  reloadCargoDocHandler(e = null) {
    this.fillView()
  }
  showDocState() {
    const isZh = this.$i18n.locale === 'zh'
    const releaseState = ReleaseState.getReleaseStateByCode(this.form.releaseState)
    if (releaseState) {
      this.view.lblReleaseState = isZh ? releaseState.chineseName : releaseState.englishName
    }
  }
  async loadCargoDoc2Handler(cargoDocList) {
    this.form = null
    this._hblCargoDoc = null
    const cargoDocs = []
    if (cargoDocList && cargoDocList.length > 0) {
      for (const hCargoDoc of cargoDocList) {
        if (hCargoDoc.docType === CargoDocConsts.HBL) {
          this._hblCargoDoc = hCargoDoc
        } else if (hCargoDoc.docType === CargoDocConsts.HBL2) {
          cargoDocs.push(hCargoDoc)
        }
      }
      this.view.splitOrder.rowData = cargoDocs
    }
    console.log('cargoDocs', cargoDocs)
    if (cargoDocs.length > 0) {
      this.form = cargoDocs[0]
    } else {
      if (this.job.typeHBL === BillType.MERGE_BILL_TYPE.code) {
        await this.onAddCargoDoc2()
      } else {
        /* 不存到数据库 */
        this.form = new SeaImCargoDoc().fillDefaultValue().getData()
      }
    }
    if (this.form.uuid && !this.form.paymentTerm) {
      const paymentTerm = this.paymentTermList.find(p => p.code === this.job.paymentTermHBL)
      this.form.paymentTerm = paymentTerm ? paymentTerm.name : ''
    }

    // 赋值 AFR最后一票 勾选框
    for (const hCargoDoc of cargoDocs) {
      this.view.chkConsolidationClosed = false
      if (hCargoDoc.uuid) {
        const afrAddress = await new SeaImCargoDoc(hCargoDoc).getAfrAddress()
        if (afrAddress && afrAddress.length > 0) {
          this.loadAfrAddressHandler(afrAddress[0])
          hCargoDoc.chkConsolidationClosed = afrAddress[0].consolidationClosed > 0
        } else {
          hCargoDoc.chkConsolidationClosed = false
        }
      }
    }

    this.editingChanged()
    this.checkReleaseTypeState()
    this.loadSplitMBLs()

    await this.showScac()
    await this.showDocState()
    this.refreshSeaeqNumber()
    this.view.$nextTick(() => { // 选中新增项
      if (this.view.splitOrder.gridOptions.api) {
        const nodes = this.view.splitOrder.gridOptions.api.getRenderedNodes()
        if (nodes.length > 0) {
          nodes[0].setSelected(true)
        }
      }
    })
  }
  loadJointSlaves2Handler(jointSlavesHBL) {
    this.view.mergeOrder.rowData = jointSlavesHBL
    this.printStateChange()
  }
  showScac() {
    const company = this.context.companyList.find(p => p.cmpIdx === this.job.carrierId)
    this.view.txtCarrierScAc = company ? company.scac : ''
    const company1 = this.context.companyList.find(p => p.cmpIdx === this.job.destinationAgent)
    this.view.txtBookingAgentScAc = company1 ? company1.scac : ''
  }
  loadAfrAddressHandler(afrAddress) {
    this.view.chkConsolidationClosed = afrAddress && afrAddress.consolidationClosed > 0
  }
  refreshSeaeqNumber() {
    // this.form.containerSum = ContainerUtil.getSeaeqNumberStr(this.job)
  }
  refreshQuantitySum() {
    const packing = this.packingList.find(p => p.code === this.form.packing)
    this.form.quantitySum = StrUtils.jsdx(this.form.quantity, packing ? packing.name : '')
  }

  printStateChange() {
    this.view.btnPrintDisabled = true
    if (this.view.isEdit) {
      return
    }
    // 是否异地放单 ,如果是TRUE，正本打印、电放按钮无法打印
    if (this.form.oversea && this.form.releaseType === 1) {
      return
    }
    if (this.form.releaseType === 1) {
      if (this.view.$checkPermission(['button_printDoc'])) {
        if (this.form.state) {
          this.view.btnPrintDisabled = false
        }
      }
    } else if (this.form.releaseType === BillReleaseType.SURRENDERED.code) {
      // 有权限才行
      if (this.view.$checkPermission(['button_HBL_surrender'])) {
        this.view.btnPrintDisabled = false
      }
    } else {
      this.view.btnPrintDisabled = false
    }
    if (this.job.shutOut && !this.view.btnPrintDisabled) {
      this.view.btnPrintDisabled = true
    }
  }
  /**
   * 选择开航日期更新分单签单日期，订舱航期
   */
  ETD_changeCl() {
    if (this.job.etd) {
      // 分单签单日期默认更改只能前后三天内
      const etd = moment(this.job.etd)
      const nextDay = etd.add(4, 'd')
      const fourDaysAgo = etd.subtract(4, 'd')
      if (this.view.$checkPermission(['filter_SEBooking_hblSignDate'])) {
        this.dfSignDateHBLDisabledRanges = null
      } else {
        this.dfSignDateHBLDisabledRanges = [{ rangeStart: nextDay }, { rangeEnd: fourDaysAgo }]
      }
    } else {
      this.dfSignDateHBLDisabledRanges = null
    }
  }
  /**
   * bug 996:如果HBL是已送出状态，则不允许更改“提单方式”
   */
  checkReleaseTypeState() {
    // if (!view.isEditing || view.cargoDoc == null) return
    // var bool = true
    // for each(var f: File in view.job.file)
    // {
    //   if (f.fileType == FileType.HBL_TYPE.code.toString() && f.state > 0) {
    //     bool = false
    //     break
    //   }
    // }
    // view.cmbreleaseTypeHBL.enabled = bool
  }
  /**
   * 加载主单拆单信息
   */
  loadSplitMBLs() {
    if (this.job.typeHBL !== BillType.SPLIT_BILL_TYPE.code) {
      return
    }
    this.joinMBLs.splice(0, this.joinMBLs.length)
    for (const doc of this.job.seaCargoDoc) {
      if (doc.docType === CargoDocConsts.MBL2 && this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code && !doc.deleted) {
        if (!this.joinMBLs.includes(doc)) {
          this.joinMBLs.push(doc)
        }
      }
    }
    console.log('joinMBLs', this.joinMBLs)
    this.joinMBLs = sortByMultiFieldAndOrder(this.joinMBLs, { mblNbr2: 'asc' })
  }
  changeAfrAddress() {
    // 非选中状态，清除新增的afrAddress，避免保存无用数据(新增状态先选中后又取消的场景)
    if (!this.form.chkConsolidationClosed) {
      if (this.form.afrAddress && this.form.afrAddress.length > 0) {
        if (this.form.afrAddress[0].uuid) {
          this.form.afrAddress[0].consolidationClosed = this.form.chkConsolidationClosed ? 1 : 0
        } else {
          this.form.afrAddress = []
        }
      }
      return
    }

    if (this.form.chkConsolidationClosed) {
      let afrAddress = null
      if (!this.form.afrAddress || this.form.afrAddress.length === 0) {
        this.form.afrAddress = []
        afrAddress = new AfrAddress().fillDefaultValue().getData()
        afrAddress.state = 0
        afrAddress.docType = CargoDocConsts.AFR
        afrAddress.cargoDocUuid = this.form.uuid
        this.form.afrAddress.push(afrAddress)
      } else {
        afrAddress = this.form.afrAddress[0]
      }
      if (afrAddress) {
        afrAddress.consolidationClosed = this.form.chkConsolidationClosed ? 1 : 0
      }
    }
  }
  /**
   * 编辑船名航次模式
   */
  editInputVesselModel() {
    this._allowEditingVessel = false
    switch (this.editVesselVoyageMode) {
      case 1:
        this._allowEditingVessel = true
        break
      case 2:
        if (this.job.bookingTerm !== BookingTerm.OS_BOOKING_TYPE.code) {
          this._allowEditingVessel = true
        }
        break
      case 3:
        this._allowEditingVessel = false
        break
      default:
        break
    }
  }
  /**
   * 拼箱小票，不允许编辑：目的港代理、船名、航次、订舱单位、船公司、主单运费条款、卸货港
   */
  lclslaveEnabledCl() {
    this._lclslaveEnabled = this.view.isEdit && !this.job.lclMasterUuid
  }
  editingChanged() {
    this.printStateChange()
    this.lclslaveEnabledCl()
  }
  /**
   * clear input
   */
  onClear(type) {
    switch (type) {
      case 1:
        this.form.shipperCode = ''
        this.form.shipperLine1 = ''
        this.form.shipperLine2 = ''
        this.form.shipperLine3 = ''
        this.form.shipperLine4 = ''
        this.form.shipperLine5 = ''
        this.form.shipperLine6 = ''
        this.form.shipperLine7 = ''
        break
      case 2:
        this.form.consigneeCode = ''
        this.form.consigneeLine1 = ''
        this.form.consigneeLine2 = ''
        this.form.consigneeLine3 = ''
        this.form.consigneeLine4 = ''
        this.form.consigneeLine5 = ''
        this.form.consigneeLine6 = ''
        this.form.consigneeLine7 = ''
        break
      case 3:
        this.form.notifyCode = ''
        this.form.notifyLine1 = ''
        this.form.notifyLine2 = ''
        this.form.notifyLine3 = ''
        this.form.notifyLine4 = ''
        this.form.notifyLine5 = ''
        this.form.notifyLine6 = ''
        this.form.notifyLine7 = ''
        break
      case 4:
        this.form.agentPartyLine1 = ''
        this.form.agentPartyLine2 = ''
        this.form.agentPartyLine3 = ''
        this.form.agentPartyLine4 = ''
        this.form.agentPartyLine5 = ''
        this.form.agentPartyLine6 = ''
        this.form.agentPartyLine7 = ''
        break
      default:
        break
    }
  }
}
